import moment from 'moment';

const getGiveawayBriefResponse = (response) => {
  const { data } = response ?? {};
  
  if (!data?.giveaways) {
    return response;
  }

  const formatDate = (dateStr) => moment(dateStr).format('DD MMMM YYYY');
  const formatTimeRange = (startTime, endTime) => 
    `${startTime.slice(0, 5)} - ${endTime.slice(0, 5)}`;

  const transformedGiveaways = data.giveaways.map(giveaway => {
    const transformedData = (giveaway.data || []).map(timeGroup => ({
      startTime: timeGroup.startTime,
      endTime: timeGroup.endTime,
      isEditable: timeGroup.isEditable,
      timeRange: formatTimeRange(timeGroup.startTime, timeGroup.endTime),
      giveaways: (timeGroup.giveaways || []).map(item => ({
        ...item,
        remainingStock: (item.allocatedStock ?? 0) - (item.usedStock ?? 0),
      })),
    }));

    return {
      ...giveaway,
      promotionDate: formatDate(giveaway.promotionDate),
      data: transformedData
    };
  });

  return {
    giveaways: transformedGiveaways
  };
};

export default getGiveawayBriefResponse;